export const SPACE = '\u0020';
export const NO_BREAK_SPACE = '\u00A0';
export const INFORMATION_SEPARATOR_ONE = '\u001F';
export const ZERO_WIDTH_SPACE = '\u200B';
export const SOFT_HYPHEN = '\u00AD';
export const HYPHEN_MINUS = '\u002D';
export const EN_DASH = '\u2013';
export const EM_DASH = '\u2014';
export const NARROW_NO_BREAK_SPACE = '\u202F';
